import Backbone from "backbone";
import _ from "underscore";
import ProgramDomainModel from "src/shared/program-domains/ProgramDomainModel";

const ProgramDomainCollection = Backbone.Collection.extend({
    model: ProgramDomainModel,
    url: "/api/v2/programs/",
});

ProgramDomainCollection.create = () => {
    return new ProgramDomainCollection();
};

export default ProgramDomainCollection;
